import { render, staticRenderFns } from "./OwnerHistoryList.vue?vue&type=template&id=c90053b8&scoped=true&"
import script from "./OwnerHistoryList.vue?vue&type=script&lang=js&"
export * from "./OwnerHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerHistoryList.vue?vue&type=style&index=0&id=c90053b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90053b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
